/** @jsx jsx */
import { css, jsx } from "@emotion/react"
import React, { useContext, useState, useEffect, useRef } from "react"
import StateContext from "../../../../context/state/StateContext"
import { getMySingleForm } from "../../../../helpers/DrupalHelper"
import DynamicForm from "../DynamicForm"
import AsyncFloatingSelect from "../../../Elements/Form/AsyncFloatingSelect"
import ButtonEdit from "../../../Elements/ButtonEdit"
import CustomLocationForm from "../../CustomLocationForm"
function GeoLocations({
  onChange,
  label,
  errors,
  name,
  hookForm,
  register,
  defaultValue,
  data,
  token,
  setValue,
  required,
  unregister,
  fromAddressPage,
  control,
}) {
  const [formData, setFormData] = useState(null)
  const [customActive, setCustomActive] = useState(false)
  const pRef = useRef(null)
  const containerRef = useRef(null)
  const { state } = useContext(StateContext)

  useEffect(() => {
    let isMounted = true
    const fetchFormData = async () => {
      const formData = await getMySingleForm(state.token, "location")
      if (isMounted) {
        setFormData(formData)
      }
    }
    fetchFormData()
    return () => {
      isMounted = false
    }
  }, [state.token])
  const [placeValue, setPlaceValue] = useState(null)
  const [customError, setCustomError] = useState(false)
  const [disable, setDisable] = useState(data?.current_value ? true : false)

  useEffect(() => {
    if (placeValue !== null && customError === true) {
      setCustomError(false)
    }
  }, [placeValue])

  useEffect(() => {
    if (customActive && containerRef.current) {
      try {
        containerRef.current.scrollIntoView({ behavior: "smooth", block: "center" })
      } catch (e) {}
    }
  }, [customActive])
  const onSave = data => {
    let values = Object.values(data).filter(Boolean)
    let strAdd = values.toLocaleString().replaceAll(",", ", ")
    // console.log(values, strAdd)
    setValue("customBodyLocation", {
      name: name,
      body: {
        entity_title: strAdd,
        json: {
          field_location_address: { ...data },
          field_location_shortname: strAdd,
        },
      },
    })
  }
  useEffect(() => {
    register(name, { required: "This field is required" })

    register("customBodyLocation")
    return () => {
      unregister(name)
      unregister("customBodyLocation")
    }
  }, [])
  useEffect(async () => {
    // console.log(placeValue)
    // console.log(pRef)
    let token = ""
    if (pRef?.current !== null) {
      let { getSessionToken } = pRef.current
      token = getSessionToken()
      // console.log(token)
    }
    if (placeValue !== null) {
      // geocodeByPlaceId(placeValue.value.place_id)
      // Commented out unused fetch - Google Places API is used via GooglePlacesAutocomplete component
    }
  }, [placeValue])

  return (
    <>
      <div
        ref={containerRef}
        className={`relative z-[222] ${!fromAddressPage ? "mb-6" : "mb-6"} w-full group`}
      >
        {!customActive && (
          <>
            {customError === true && (
              <p className="text-reg-17 !text-[11px] -bottom-[15px] absolute red">
                We couldn't confirm this as a valid store address. You must
                specify a full address.
              </p>
            )}
            <AsyncFloatingSelect
              label={"..."}
              name={"..."}
              hookForm
              // register={register}
              error={errors["field_group_stores"]}
              control={control}
              required={required}
              defaultValue={
                data.current_value && data.current_value.length
                  ? Object.assign({
                      value: data.current_value[0].target_id,
                      label: data.current_value[0].title,
                    })
                  : null
              }
              isDisabled={disable}
              body={{
                bundle: "default",
                entity: "location",
              }}
              isMulti={false}
              placeholder={"Start typing to find your address..."}
              minChars={3}
              notFoundButton={true}
              notFoundButtonTitle="Can't find your location?"
              notFoundButtonF={() => {
                setTimeout(() => {
                  setCustomActive(true)

                  try {
                    unregister(name)
                  } catch (e) {}
                }, 0)
              }}
              customOnChange={async v => {
                if (v?.value) setValue(name, v.value)
                else setValue(name, null)
                // setShowLoc(true)
                // let data = await getRetailStoresLocation(state.token, v.value)
                // console.log(data)
                // setStoreLocation(data)
              }}
            />
            <label
              htmlFor={"address"}
              className="absolute duration-300 transform -translate-y-7 scale-75 top-[15px] left-[12px] z-1 origin-[0] px-[8px] --rm-peer-focus:text-blue-600 peer-placeholder-shown:scale-100  peer-placeholder-shown:-z-10 peer-placeholder-shown:bg-transparent peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-7 bg-white peer-focus:bg-white peer-focus:z-10"
              css={css`
                font-family: "Jost";
                font-style: normal;
                font-weight: 400;
                font-size: 15px;
                line-height: 28px;
                letter-spacing: 0.02em;
                color: #717171;
                background: #fff;
                background: ${disable
                  ? "linear-gradient(180deg, #fff 0%, #fff 12.6px, #ebebeb 12.6px, #eee 13.6px)"
                  : "#fff"};
              `}
            >
              {label ? label : "Address"}
            </label>
            {errors[name] && <span>{errors[name]["message"]}</span>}
            <div className="flex space-y-2 md:space-y-0 flex-col md:flex-row md:items-center mt-2">
              {data?.description && (
                <span
                  className="md:pr-4"
                  css={css`
                    font-family: "Jost";
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 16px;
                    display: inline-block;
                    padding: 0 10px;
                    letter-spacing: 0.02em;
                    color: #717171;
                  `}
                >
                  {data.description}
                </span>
              )}
              {data?.current_value && disable && (
                <div className="flex justify-end md:ml-auto mt-[-11px] mb-[10px]">
                  <ButtonEdit
                    onClick={() => setDisable(false)}
                    text={"Change address"}
                  />
                </div>
              )}
            </div>
          </>
        )}

        {customActive && (
          <>
            <div className="mb-4 flex items-center justify-between">
              <span className="text-[#717171] text-sm">Enter address manually</span>
              <button
                type="button"
                className="text-sm text-red-600 hover:underline"
                onClick={() => {
                  setCustomActive(false)
                  try {
                    // Re-register field to restore original async select when returning
                    register(name, { required: "This field is required" })
                  } catch (e) {}
                  // Scroll back to the container for context
                  requestAnimationFrame(() => {
                    if (containerRef.current) {
                      containerRef.current.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                  })
                }}
              >
                Back to search
              </button>
            </div>

            <CustomLocationForm key="custom-location-form" onSave={onSave} />
          </>
        )}
      </div>
    </>
  )
}

export default GeoLocations
